/// Coarse pointer ≈ phone / tablet. Fine pointer ≈ mouse / trackpad desktop.

import { useSyncExternalStore } from 'react';

const coarseQuery = '(pointer: coarse)';

export function isCoarsePointer(): boolean {
  if (typeof window === 'undefined') return false;
  return window.matchMedia(coarseQuery).matches;
}

export function useCoarsePointer(): boolean {
  return useSyncExternalStore(subscribeCoarse, isCoarsePointer, () => false);
}

function subscribeCoarse(onChange: () => void): () => void {
  const media = window.matchMedia(coarseQuery);
  media.addEventListener('change', onChange);
  return () => media.removeEventListener('change', onChange);
}
